module.exports = __webpack_public_path__ + "img/hiw.ff8d68df.png";